"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _icon = _interopRequireDefault(require("../icon"));

var _component = _interopRequireDefault(require("../base/component"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var animateScrollTop = function animateScrollTop(element, value, duration) {
  var targetDom = element;

  var createTime = function createTime() {
    return new Date().getTime();
  };

  var startPosition = element.scrollTop;
  var endPosition = parseInt(value, 10) * 28;
  var offset = endPosition - startPosition;
  var startTime = createTime();
  var timerId = setInterval(function () {
    var remaining = Math.max(0, startTime + duration - createTime());
    var percent = 1 - (remaining / duration || 0);
    var now = offset * percent + startPosition;
    targetDom.scrollTop = now;

    if (percent === 1) {
      clearInterval(timerId);
      timerId = null;
    }
  }, 16);
};

var paddingZero = function paddingZero(number) {
  return number < 10 ? "0".concat(number) : "".concat(number);
};

var TimePanel = /*#__PURE__*/function (_KZUIComponent) {
  _inherits(TimePanel, _KZUIComponent);

  var _super = _createSuper(TimePanel);

  function TimePanel(props) {
    var _this;

    _classCallCheck(this, TimePanel);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "hours", void 0);

    _defineProperty(_assertThisInitialized(_this), "minutes", void 0);

    _defineProperty(_assertThisInitialized(_this), "seconds", void 0);

    _defineProperty(_assertThisInitialized(_this), "hourParent", void 0);

    _defineProperty(_assertThisInitialized(_this), "minuteParent", void 0);

    _defineProperty(_assertThisInitialized(_this), "secondParent", void 0);

    _this.autoBind('handleClose', 'handleHourClick', 'handleMinuteClick', 'handleSecondClick');

    _this.hours = [];

    for (var i = 0; i < 24; i += 1) {
      _this.hours.push(i);
    }

    _this.minutes = [];

    for (var _i = 0; _i < 60; _i += 1) {
      _this.minutes.push(_i);
    }

    _this.seconds = _this.minutes.slice();
    return _this;
  }

  _createClass(TimePanel, [{
    key: "initStateFromProps",
    value: function initStateFromProps(props) {
      return {
        hour: props.hour,
        minute: props.minute,
        second: props.second
      };
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      animateScrollTop(this.hourParent, this.state.hour, 200);
      animateScrollTop(this.minuteParent, this.state.minute, 200);
      animateScrollTop(this.secondParent, this.state.second, 200);
    }
  }, {
    key: "handleClose",
    value: function handleClose() {
      var _this$props$onClose, _this$props;

      (_this$props$onClose = (_this$props = this.props).onClose) === null || _this$props$onClose === void 0 ? void 0 : _this$props$onClose.call(_this$props);
    }
  }, {
    key: "handleHourClick",
    value: function handleHourClick(value) {
      var _this$props$onChange, _this$props2;

      this.setState({
        hour: value
      });
      (_this$props$onChange = (_this$props2 = this.props).onChange) === null || _this$props$onChange === void 0 ? void 0 : _this$props$onChange.call(_this$props2, {
        hour: value
      });
    }
  }, {
    key: "handleMinuteClick",
    value: function handleMinuteClick(value) {
      var _this$props$onChange2, _this$props3;

      this.setState({
        minute: value
      });
      (_this$props$onChange2 = (_this$props3 = this.props).onChange) === null || _this$props$onChange2 === void 0 ? void 0 : _this$props$onChange2.call(_this$props3, {
        minute: value
      });
    }
  }, {
    key: "handleSecondClick",
    value: function handleSecondClick(value) {
      var _this$props$onChange3, _this$props4;

      this.setState({
        second: value
      });
      (_this$props$onChange3 = (_this$props4 = this.props).onChange) === null || _this$props$onChange3 === void 0 ? void 0 : _this$props$onChange3.call(_this$props4, {
        second: value
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var clsPrefix = 'kui-time-picker';
      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "-time-panel")
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "-panel-header")
      }, /*#__PURE__*/React.createElement("span", {
        className: "".concat(clsPrefix, "-panel-header-title")
      }, "\u9009\u62E9\u65F6\u95F4"), /*#__PURE__*/React.createElement(_icon["default"], {
        type: "close-new",
        onClick: this.handleClose
      })), /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "-panel-body")
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "-panel-body-item"),
        ref: function ref(c) {
          _this2.hourParent = c;
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "-item-container")
      }, this.hours.map(function (item) {
        return /*#__PURE__*/React.createElement(PickItem, {
          key: "hour-".concat(item),
          onClick: _this2.handleHourClick,
          value: item,
          active: item === _this2.state.hour
        });
      }))), /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "-panel-body-item"),
        ref: function ref(c) {
          _this2.minuteParent = c;
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "-item-container")
      }, this.minutes.map(function (item) {
        return /*#__PURE__*/React.createElement(PickItem, {
          key: "minute-".concat(item),
          onClick: _this2.handleMinuteClick,
          value: item,
          active: item === _this2.state.minute
        });
      }))), /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "-panel-body-item"),
        ref: function ref(c) {
          _this2.secondParent = c;
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "-item-container")
      }, this.seconds.map(function (item) {
        return /*#__PURE__*/React.createElement(PickItem, {
          key: "second-".concat(item),
          onClick: _this2.handleSecondClick,
          value: item,
          active: item === _this2.state.second
        });
      })))));
    }
  }]);

  return TimePanel;
}(_component["default"]);

var PickItem = function PickItem(_ref) {
  var active = _ref.active,
      value = _ref.value,
      onClick = _ref.onClick;

  var handleClick = function handleClick() {
    onClick(value);
  };

  if (active) {
    return /*#__PURE__*/React.createElement("span", {
      className: "active",
      onClick: handleClick
    }, paddingZero(value));
  }

  return /*#__PURE__*/React.createElement("span", {
    onClick: handleClick
  }, paddingZero(value));
};

var _default = TimePanel;
exports["default"] = _default;